var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 5,
    viewBox: "0 0 19 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20833 0.414062C1.0625 0.414062 0.125 1.35156 0.125 2.4974C0.125 3.64323 1.0625 4.58073 2.20833 4.58073C3.35417 4.58073 4.29167 3.64323 4.29167 2.4974C4.29167 1.35156 3.35417 0.414062 2.20833 0.414062ZM16.7917 0.414062C15.6458 0.414062 14.7083 1.35156 14.7083 2.4974C14.7083 3.64323 15.6458 4.58073 16.7917 4.58073C17.9375 4.58073 18.875 3.64323 18.875 2.4974C18.875 1.35156 17.9375 0.414062 16.7917 0.414062ZM9.5 0.414062C8.35417 0.414062 7.41667 1.35156 7.41667 2.4974C7.41667 3.64323 8.35417 4.58073 9.5 4.58073C10.6458 4.58073 11.5833 3.64323 11.5833 2.4974C11.5833 1.35156 10.6458 0.414062 9.5 0.414062Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.21c265002ba35127892b3eee645654e4.svg";
export { ForwardRef as ReactComponent };